import React, { Component } from 'react';
import {Button} from 'reactstrap';
import ReviewSuccess from './../../../assets/mapping_success.svg';

class MapSuccessManagement extends Component {
  state = {type : null}
  componentDidMount() {
    const {state} = this.props.location; 
    this.setState({
      type :  state.type
    });
  }

  render() { 
    const {type} = this.state;
    return ( 
      <div className="mt50">
        <div className="text-center">
          <img src={ReviewSuccess} style={{height:'150px'}}/>
          <div className="mt40" style={{width:'80%',marginLeft:'auto',marginRight:'auto'}}>
            Congratulations! You have successfully mapped your {type} information to standardized categories. 
            Offices in your enterprise can now track selected KPIs by 
            {
              type === 'positions' ? 
              ` occupational and job categories.` : 
              type === 'separation' ? 
              ' separation types.' : 
              type === 'disability'?
              ' disabilities':
               ` ${type}` + "."
            }
          </div>
          <div className="row justify-content-center mt40">
            <div className="col-md-3 col-lg-3">
              <Button className="float-right continueBtn w100" 
                onClick={() => {this.props.history.push('/home/enterprise-info')}}>
                <span className="continueBtnTxt">
                  Done
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
 
export default MapSuccessManagement;